// Default breakpoints are too far apart for good UX
export const mobileToDesktopNavBreakpointPx = 1072;
